//import { slick } from "@accessible360/accessible-slick";
import Swiper from "swiper";
import {
    EffectFade,
    FreeMode,
    Keyboard,
    Pagination,
} from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/keyboard";

class Quotes {
    constructor(element) {
        // Class properties.
        this.el = element;
        this.quoteCarouselEl = this.el.querySelector(".swiper");
        this.quoteSwiper = null;
        
        this.init();
    }

    init() {
        this.instantiateSwiper();
        
    }

    instantiateSwiper() {
        // Instantiate the main carousel.

        if (this.quoteCarouselEl) {
           
            this.quoteSwiper = new Swiper(this.quoteCarouselEl, {
                loop: true,
                spaceBetween: 8,
                speed: 1000,
                autoHeight: true,
                effect: "fade",
                loopPreventsSliding: false,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                fadeEffect: {
                    crossFade: true,
                },
                grabCursor: true,
                pagination: {
                    el: ".swiper-pagination",
                    type: 'bullets',
                    clickable: true,
                },
                containerRole: `region`,
                containerRoleDescriptionMessage: `Quotes carousel`,
                modules: [EffectFade, Keyboard, Pagination],
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const quoteCarousels = document.querySelectorAll('.quotes');

    quoteCarousels.forEach((element) => {
        new Quotes(element);
    });
});

export default Quotes;
